<div
  fxLayout.mm-mobile="column"
  fxLayout.mm-tablet="column"
  fxLayout.mm-tablet-landscape="column"
  class="header-topline">
  <ng-container  *ngFor="let item of externalLinks; trackBy: trackById">
    <a
    *ngIf="item.showMobile"
    class="header-topline__link"
    rel="noopener noreferrer"
    [ngClass]="{'header-topline__link--desktop': !isMobile, 'header-topline__link--mobile': isMobile}"
    [href]="item.link"
    (click)="handleExternalLinkTracking(item.trackingLabel)">
    {{ item.title | translate }}
  </a>
  </ng-container>

</div>
